export const productArea = {
    broadband: 2,
    mobilePhones: 3,
    payTv: 6,
    tablets: 11
};
